export function normalizeName(value) {
  return (value || '').trim().toLowerCase();
}

export function setByName(target, item) {
  target[normalizeName(item.name)] = item;
}

export function getByName(target, name) {
  return target[normalizeName(name)];
}

export function escapeHtml(value) {
  return String(value || '')
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#39;');
}

export function formatPageList(pages) {
  const normalized = [...new Set((pages || [])
    .map((value) => String(value).trim())
    .filter(Boolean))];

  const parts = [];
  let i = 0;
  while (i < normalized.length) {
    const current = normalized[i];
    if (!/^\d+$/.test(current)) {
      parts.push(current);
      i += 1;
      continue;
    }

    let start = Number(current);
    let end = start;
    let j = i + 1;

    while (j < normalized.length && /^\d+$/.test(normalized[j])) {
      const next = Number(normalized[j]);
      if (next !== end + 1) {
        break;
      }
      end = next;
      j += 1;
    }

    parts.push(start === end ? String(start) : `${start}-${end}`);
    i = j;
  }

  return parts.join(', ');
}

export function createEntityLink(entityType, name) {
  return `<button class="entity-link" data-entity-type="${entityType}" data-entity-name="${encodeURIComponent(name)}">${escapeHtml(name)}</button>`;
}

export function createEntityLinkWithLabel(entityType, name, label, options = {}) {
  const { hasInfo = false } = options;
  const infoBadge = hasInfo ? '<span class="browse-info-icon" aria-hidden="true">i</span>' : '';
  return `<button class="entity-link" data-entity-type="${entityType}" data-entity-name="${encodeURIComponent(name)}">${escapeHtml(label)}${infoBadge}</button>`;
}

export function sortEntityNames(names) {
  return [...names].sort((a, b) => a.localeCompare(b, undefined, {
    sensitivity: 'base',
    numeric: true
  }));
}
